import React from 'react';

class PageNotFound extends React.Component {

    render () {
        return (      
        <div className="home">
        <h1 className="title">404</h1>
        <h2 className="title">Page Not found</h2>
        </div>
    )
    }
}

export default PageNotFound;